module.exports = __webpack_public_path__ + "static/img/rectangle06.d319b28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle06.jpg
// module id = H1la
// module chunks = 0